import _ from "lodash";
import * as React from "react";

interface IProps {
    newsfeed: any;
}

export default ({ newsfeed }: IProps) => {
    return newsfeed !== undefined && !_.isEmpty(newsfeed) ?
        <div className="NR_feeds">
            <div className="CMS_title CMS_T6">
                <em className="fa fa-newspaper-o"></em> News Feed
            </div>
            <span className="NR_feed">{newsfeed}</span>
        </div> : null;
};
